import { render, staticRenderFns } from "./cardFavorite.vue?vue&type=template&id=df6d56e0&scoped=true&"
import script from "./cardFavorite.vue?vue&type=script&lang=js&"
export * from "./cardFavorite.vue?vue&type=script&lang=js&"
import style0 from "./cardFavorite.vue?vue&type=style&index=0&id=df6d56e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6d56e0",
  null
  
)

component.options.__file = "cardFavorite.vue"
export default component.exports